import type { AbilityBuilder } from '@casl/ability';

import type { AppAbility } from './ability';
import type { Scope } from './scopes';

type Can = AbilityBuilder<AppAbility>['can'];

export const SCOPE_TO_RULES: Record<string, (can: Can) => void> = {
  'teams:read': can => can('read', 'Teams'),
  'teams:create': can => can('create', 'Teams'),
  'teams:update': can => can('update', 'Teams'),

  'players:read': can => can('read', 'Players'),
  'players:create': can => can('create', 'Players'),
  'players:update': can => can('update', 'Players'),

  'referees:read': can => can('read', 'Referees'),
  'referees:create': can => can('create', 'Referees'),
  'referees:update': can => can('update', 'Referees'),

  'tournaments:read': can => can('read', 'Tournaments'),
  'tournaments:create': can => can('create', 'Tournaments'),
  'tournaments:update': can => can('update', 'Tournaments'),

  'tour-types:read': can => can('read', 'Tournament'),
  'tour-types:create': can => can('create', 'Tournament'),
  'tour-types:update': can => can('update', 'Tournament'),

  'positions:read': can => can('read', 'Positions'),
  'positions:create': can => can('create', 'Positions'),
  'positions:update': can => can('update', 'Positions'),

  'groups:read': can => can('read', 'Groups'),
  'groups:create': can => can('create', 'Groups'),
  'groups:update': can => can('update', 'Groups'),

  'admins:read': can => can('read', 'Admins'),
  'admins:create': can => can('create', 'Admins'),
  'admins:update': can => can('update', 'Admins'),
  'admins:delete': can => can('delete', 'Admins'),

  'games:read': can => can('read', 'Games'),
  'games:create': can => can('create', 'Games'),
  'games:update': can => can('update', 'Games'),
  'games:edit:without-status': can => can('updateWithoutStatus', 'Games'),
} satisfies Record<Scope, (can: Can) => void>;
